import PropTypes from 'prop-types';

export const EmergencyHistoryShape = PropTypes.shape({
  poi_id: PropTypes.number,
  update_date: PropTypes.string,
  nick_name: PropTypes.string,
  stamp: PropTypes.string,
  report_type: PropTypes.string,
  report_status: PropTypes.bool,
});

export default PropTypes.shape({
  poi_id: PropTypes.string,
  has_power: EmergencyHistoryShape,
  has_gas: EmergencyHistoryShape,
  has_diesel: EmergencyHistoryShape,
});
